<template>
  <div class="mine_page">
    <!-- 标题按截图2：個人中心 -->
    <van-nav-bar title="個人中心" class="header_b"></van-nav-bar>

    <div class="u_bg"></div>

    <div class="content_re">
      <!-- 顶部用户信息 -->
      <div class="info_card_u">
        <div class="left_c">
          <div class="user_img_b" v-if="userInfo.header_img">
            <img :src="userInfo.header_img" alt="" class="user_set" />
          </div>
          <div class="user_img_b" v-else>
            <img src="/img/neww/userpic.png" alt="" class="user_set" />
          </div>

          <div class="tc">
            <div class="name">{{ userInfo.username }}</div>
            <!-- 按截图2：信譽分：100 -->
            <div class="credit">{{ $t('q6') }}：{{ userInfo.xinyu }}</div>
          </div>
        </div>

        <!-- 右上角齿轮：去设置 -->
        <van-icon name="setting-o" class="c_set" @click="showSetting" />
      </div>

      <!-- 两个统计卡片：積分 / 收益 -->
      <div class="c_card_b">
        <div class="hang_c">
          <div class="q1">積分</div>
          <div class="q2">{{ fmt(pointsValue) }}</div>
        </div>
        <div class="hang_c">
          <div class="q1">收益</div>
          <div class="q2">{{ fmt(profitValue) }}</div>
        </div>
      </div>

      <!-- VIP 横幅 -->
      <div class="c_vip">
        <div class="ee">{{ $t("q7") }}</div>
        <div class="down">{{ $t("q8") }}</div>
      </div>

      <!-- 菜单（按截图2顺序/文案） -->
      <div class="hang_bttn" @click="$router.push({ path: '/Withdraw' });">
        <div class="left_y">
          <img src="/img/neww/ico_txzx.png" alt="" class="cl_set" />
          <div class="text_k">{{ $t("q9") }}</div>
        </div>
        <img src="/img/neww/you.png" alt="" class="right_h" />
      </div>

      <div class="hang_bttn" @click="$router.push({ path: '/GameRecord' });">
        <div class="left_y">
          <img src="/img/neww/ico_bb.png" alt="" class="cl_set" />
          <div class="text_k">{{ $t("q10") }}</div>
        </div>
        <img src="/img/neww/you.png" alt="" class="right_h" />
      </div>

      <div class="hang_bttn" @click="$router.push({ path: '/RechargeList' });">
        <div class="left_y">
          <img src="/img/neww/ico_czjl.png" alt="" class="cl_set" />
          <div class="text_k">{{ $t("q11") }}</div>
        </div>
        <img src="/img/neww/you.png" alt="" class="right_h" />
      </div>

      <div class="hang_bttn" @click="$router.push({ path: '/WithdrawRecord' });">
        <div class="left_y">
          <img src="/img/neww/ico_tkjl.png" alt="" class="cl_set" />
          <div class="text_k">{{ $t("q12") }}</div>
        </div>
        <img src="/img/neww/you.png" alt="" class="right_h" />
      </div>

      <div class="hang_bttn" @click="$router.push({ path: '/BindCard' });">
        <div class="left_y">
          <img src="/img/neww/icon_user_card.png" alt="" class="cl_set" />
          <div class="text_k">{{ $t("q13") }}</div>
        </div>
        <img src="/img/neww/you.png" alt="" class="right_h" />
      </div>

      <!-- ✅ 新增：退出登入按钮（放在 我的金融卡 下方） -->
      <div class="logout_btn" v-if="isLogin" @click="loginout">
        {{ $t("setting.logout") }}
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      userInfo: {},
      isLoading: false,
      isLogin: false, // ✅ 不要在 template 里直接用 localStorage
    };
  },
  computed: {
    // 积分：优先 points/score，其次 money（兼容你现有字段）
    pointsValue() {
      const u = this.userInfo || {};
      return (
        u.points ??
        u.score ??
        u.integral ??
        u.jifen ??
        u.money ??
        0
      );
    },
    // 收益：优先 profit/income/shouyi（如果没有就 0）
    profitValue() {
      const u = this.userInfo || {};
      return (
        u.profit ??
        u.income ??
        u.shouyi ??
        u.earn ??
        u.revenue ??
        0
      );
    },
  },
  methods: {
    fmt(v) {
      const n = Number(v);
      if (Number.isFinite(n)) return n.toFixed(2);
      return "0.00";
    },

    showSetting() {
      if (localStorage.getItem("token")) {
        this.$router.push({ path: "/Setting" });
      } else {
        this.$router.push({ path: "/Login" });
      }
    },

    // ✅ 退出功能（从设置页搬过来，逻辑不变）
    loginout() {
      localStorage.clear();
      this.isLogin = false;

      // 立刻切回未登录展示（避免同页不刷新）
      this.userInfo = {
        username: this.$t("setting.log_reg"),
        header_img: "/img/neww/userpic.png",
        xinyu: 0,
      };

      // 你原来是在 Setting 页退出后 push 到 /Mine
      // 现在本来就在 /Mine，所以不需要重复跳；如果你不在 /Mine，也保持原行为
      if (this.$route && this.$route.path !== "/Mine") {
        this.$router.push({ path: "/Mine" });
      }
    },

    getUserInfo() {
      this.$http({
        method: "get",
        url: "user_info",
      }).then((res) => {
        if (res.code === 200) {
          this.userInfo = res.data || {};

          if (this.userInfo.status !== 1) {
            this.$toast(this.$t("video.account_out"));
            localStorage.clear();
            this.isLogin = false;
            this.$router.push({ path: "/Login" });
          }
        } else if (res.code === 401) {
          this.$toast(res.msg);
        }
      });
    },
  },
  created() {
    this.isLogin = !!localStorage.getItem("token");

    if (this.isLogin) {
      this.getUserInfo();
    } else {
      this.userInfo.username = this.$t("setting.log_reg");
      this.userInfo.header_img = "/img/neww/userpic.png";
      this.userInfo.xinyu = 0;
    }
  },
};
</script>

<style scoped lang="less">
.mine_page {
  position: relative;
  background-color: #101012;
  min-height: 100vh;
  box-sizing: border-box;
}

.header_b {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
}

::v-deep .van-nav-bar__content {
  height: 100px;
}

.u_bg {
  background: linear-gradient(to right, #efcba7, #dcab76);
  height: 300px;
  position: absolute;
  width: 100%;
}

.content_re {
  position: relative;
  width: 100%;
  padding-top: 100px;
  padding-bottom: 160px; /* 给底部按钮留空间 */
}

.info_card_u {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 40px 60px 20px 40px;
}

.left_c {
  display: inline-flex;
  align-items: center;
}

.user_set {
  width: 120px;
  border: 2px solid #fff;
  border-radius: 50%;
}

.tc {
  margin-left: 30px;
  color: #101012;
}

.name {
  font-size: 32px;
  font-weight: 600;
}

.credit {
  padding-top: 16px;
  font-size: 26px;
  opacity: 0.9;
}

.c_set {
  font-size: 44px;
  color: #2b2b2b;
}

.c_card_b {
  display: flex;
  align-items: center;
  background: linear-gradient(120deg, #212121, #313131);
  border-radius: 16px;
  margin: 0 40px;
  padding: 46px 0;
}

.hang_c {
  flex: 1;
  text-align: center;
}

.q1 {
  color: #ffffff;
  font-size: 28px;
}

.q2 {
  color: #e6b98a;
  padding-top: 18px;
  font-size: 32px;
  font-weight: 600;
}

.c_vip {
  margin: 20px 40px;
  background: url("/img/neww/user-bg.png") no-repeat center center;
  background-size: 100% 100%;
  box-sizing: border-box;
  padding: 40px 40px 40px 40px;
  color: #e6b98a;
}

.ee {
  font-size: 26px;
  font-weight: 700;
}

.down {
  font-size: 30px;
  margin-top: 10px;
}

.hang_bttn {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 20px 40px;
  border-bottom: 1px solid #333;
}

.left_y {
  display: inline-flex;
  align-items: center;
  color: #e6b98a;
}

.cl_set {
  height: 60px;
  margin-right: 20px;
}

.text_k {
  font-size: 30px;
}

.right_h {
  height: 34px;
}

::v-deep .van-nav-bar {
  background-color: #1c1c1c;
}

::v-deep .van-hairline--bottom::after {
  border-bottom-width: 0px;
}

/* 退出按钮样式（同设置页渐变） */
.logout_btn {
  margin: 40px 40px 0;
  height: 100px;
  line-height: 100px;
  border-radius: 50px;
  color: #fff;
  font-size: 40px;
  font-weight: bolder;
  text-align: center;
  border: none;
  background: linear-gradient(270deg, #e6c3a1, #7e5678);
  user-select: none;
}
</style>
